/*
 * ct-desktop-gallery-fit.js | Cosmetique Totale
 * Desktop (>=769px), ct-templates: hoofdafbeelding + thumbnails passen altijd in het scherm.
 * Breedte blijft altijd de volle kolom. Hoogte = schermruimte (header, breadcrumb,
 * thumbnails eronder eraf), maar nooit lager dan MIN_RATIO x fotobreedte: de foto wordt
 * hooguit 10% bijgesneden; is het scherm lager, dan zakken thumbnails onder de rand.
 * Thumbnails naast de foto (instelling "Naast media"): tellen niet mee in de hoogte;
 * de kolom krijgt de fotohoogte via ct-desktop-gallery-fit.css en
 * de pijlen hangen dan aan de thumbnailkolom; --ct-arrow-prev-left/--ct-arrow-next-left
 * (gemeten t.o.v. hun offsetParent) zetten ze links en rechts óp de foto.
 * CSS: assets/ct-pdp.css, blok "[data-ct-viewport-fit]".
 */
if (!customElements.get('ct-desktop-gallery-fit')) {
  const MIN_RATIO = 0.9; // minimale hoogte t.o.v. breedte (1 = altijd vierkant)
  customElements.define('ct-desktop-gallery-fit', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-images');
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(this.update);
      [this.gallery, this.gallery.closest('.grid__item')?.querySelector('ct-product-breadcrumb'), this.gallery.querySelector('.product__thumbs'), document.querySelector('#SiteHeader')].filter(Boolean).forEach(el => this.observer.observe(el));
      window.addEventListener('resize', this.update);
      window.addEventListener('load', this.update);
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.update);
      window.removeEventListener('load', this.update);
      cancelAnimationFrame(this.frame);
    }
    fit() {
      const gallery = this.gallery;
      if (!matchMedia('(min-width: 769px)').matches) {
        gallery.removeAttribute('data-ct-viewport-fit');
        gallery.style.removeProperty('--ct-gallery-main-height');
        gallery.style.removeProperty('--ct-arrow-prev-left');
        gallery.style.removeProperty('--ct-arrow-next-left');
        return;
      }
      const grid = gallery.closest('.product-grid__container');
      const photos = gallery.querySelector('.product__photos');
      const breadcrumb = gallery.closest('.grid__item')?.querySelector('ct-product-breadcrumb');
      const breadcrumbHeight = breadcrumb ? breadcrumb.getBoundingClientRect().height + parseFloat(getComputedStyle(breadcrumb).marginBottom || 0) : 0;
      if (grid) grid.style.setProperty('--ct-breadcrumb-space', breadcrumbHeight + 'px');
      const top = breadcrumbHeight + (grid || gallery).getBoundingClientRect().top + scrollY + (grid && photos ? parseFloat(getComputedStyle(photos).marginTop || 0) : 0);
      if (grid) grid.style.setProperty('--ct-gallery-sticky-top', Math.max(0, Math.round(grid.getBoundingClientRect().top + scrollY)) + 'px');
      const thumbs = gallery.querySelector('.product__thumbs');
      const thumbStyle = thumbs && getComputedStyle(thumbs);
      const thumbsBeside = thumbs?.dataset.position === 'beside';
      const thumbHeight = thumbs && !thumbsBeside && thumbStyle.display !== 'none' ? thumbs.getBoundingClientRect().height + parseFloat(thumbStyle.marginTop || 0) + parseFloat(thumbStyle.marginBottom || 0) : 0;
      const preview = document.querySelector('iframe[src*="preview-bar"]');
      const previewHeight = preview && getComputedStyle(preview).display !== 'none' ? Math.min(80, preview.getBoundingClientRect().height) : 0;
      const main = gallery.querySelector('.product__main-photos') || photos;
      const mainRect = main.getBoundingClientRect();
      const width = mainRect.width;
      const arrow = thumbsBeside && thumbs.querySelector('.product__thumb-arrow');
      const base = arrow?.offsetParent?.getBoundingClientRect();
      if (base) {
        const arrowWidth = arrow.offsetWidth || 42;
        gallery.style.setProperty('--ct-arrow-prev-left', Math.round(mainRect.left - base.left + 16) + 'px');
        gallery.style.setProperty('--ct-arrow-next-left', Math.round(mainRect.right - base.left - 16 - arrowWidth) + 'px');
      }
      const fitHeight = innerHeight - top - thumbHeight - previewHeight - 24;
      const size = Math.max(64, Math.floor(Math.min(width, Math.max(fitHeight, width * MIN_RATIO))));

      // 1px-verschil negeren: voorkomt heen-en-weer rekenen als thumbnails meeschalen
      const current = parseFloat(gallery.style.getPropertyValue('--ct-gallery-main-height'));
      if (Math.abs(current - size) <= 1) { gallery.setAttribute('data-ct-viewport-fit', ''); return; }

      gallery.style.setProperty('--ct-gallery-main-height', size + 'px');
      gallery.setAttribute('data-ct-viewport-fit', '');
    }
  });
}
